
import config from "@/utils/ossinfo";
const OSS = require('ali-oss')
const stream = require('stream')
function timestampToTime(timestamp, type) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
    var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    if (type == 'YMD') {
        return Y + M + D;
    }
    return Y + M + D + ' ' + h + m + s;
}
export function uploadimgtooss(file) {
    return new Promise(async (resolve, reject) => {
        const contentType = file['name'].split(".")[1];

        const client = new OSS({
            bucket: config.bucket,
            region: config.region,
            accessKeyId: config.accessKeyId,
            accessKeySecret: config.accessKeySecret,
        });
        var timestamp = Date.parse(new Date())
        timestamp = Math.floor(timestamp / 1000)
        var chars = 'abcdefghijklmnopqrstuvwxyz12345678'
        var name = ""
        for (var i = 0; i <= 20; i++) {
            name += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        var fildername = timestampToTime(timestamp, 'YMD')
        console.log('fildername=====', fildername)
        let result = await client.multipartUpload(fildername + '/' + timestamp + name + '.' + contentType, file.raw);
        var url = 'http://' + config.bucket + '.' + config.region + '.aliyuncs.com/' + result.name
        resolve(url);
    })
}


export function getBase64(file) {
    return new Promise(async (resolve, reject) => {
        let reader = new FileReader();
        let base64 = "";
        reader.readAsDataURL(file.raw);
        reader.onload = () => {
            base64 = reader.result;
        };
        reader.onerror = err => {
            reject(err);
        };
        reader.onloadend = () => {
            resolve(base64);
        };
    })
}



// WEBPACK FOOTER //
// ./src/utils/uploadoss.js